module.exports = __webpack_public_path__ + "img/Dr-Mauricio-Aldrete-Lopez.83582419.jpg";